import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {WebsiteBoxFloatProgramComponent} from './website-box-float-program.component'
import {BrowserModule} from '@angular/platform-browser'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {SharedModule} from '../shared/shared.module'
import {RouterModule} from '@angular/router'
import {NgxJsonLdModule} from 'ngx-json-ld'
import {RichsnipetService} from 'dmmp-services'
import {RemoveHtmlPipe} from '../../pipes/removeHtml.pipe'
@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    SharedModule,
    RouterModule,
    NgxJsonLdModule
  ],
  declarations: [WebsiteBoxFloatProgramComponent],
  exports: [
    WebsiteBoxFloatProgramComponent
  ],
  providers: [RichsnipetService, RemoveHtmlPipe]
})
export class WebsiteBoxFloatProgramModule {
}
